import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, Grid } from "@material-ui/core";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { generatePath, useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useAppSelector } from "../../app/hooks";
import { CxQuestionPage } from "../../entity/entities";
import { appPath, paramName } from "../../router/AppRoute";
import { answeredToPage, pageAnswered, sendAnswer } from "./inputAnswerSlice";
import DATA_QA from "../../util/DataQaAttr";

export function Buttons(props: {
  pageIndex: number,
  cxQuestionPages: CxQuestionPage[],
}) {

  const {
    pageIndex,
    cxQuestionPages,
  } = props;

  const { t } = useTranslation()
  const dispatch = useDispatch();
  const history = useHistory();

  const isTest = useAppSelector(state => {
    return state.inputAnswer.session.cxHttpRes?.isTest;
  });

  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const isPageAnswered = useAppSelector((state) => {
    return pageAnswered({
      state: state.inputAnswer,
      pageIndex,
    })
  });
  const errorCount = useAppSelector((state) => state.inputAnswer.errorCount);
  const isCommonQR = useAppSelector(
    (state): boolean =>
      !!state.inputAnswer.session.cxHttpRes?.data?.cxAppSession.shopqr?.token
        ?.isCommon
  );


  let sendTitle = t('question.btn.send_response');
  if (isTest === true) {
    sendTitle = t('question.btn.send_test');
  }

  const handleSendClick = () => {

    // 全て必須項目に回答済みかチェック
    if (!isPageAnswered) {
      setErrorMessage(t('common.error.there_is_an_unanswered_question'));
      setOpen(true);
      return false;
    }

    // Invalid inputs
    if (errorCount > 0) {
      setErrorMessage(t('common.error.an_item_was_not_filled_in_correctly'));
      setOpen(true);
      return;
    }

    dispatch(sendAnswer());
  }

  const handleNextClick = () => {

    // 全て必須項目に回答済みかチェック
    if (!isPageAnswered) {
      setErrorMessage(t('common.error.there_is_an_unanswered_question'));
      setOpen(true);
      return false;
    }

    // Invalid inputs
    if (errorCount > 0) {
      setErrorMessage(t('common.error.an_item_was_not_filled_in_correctly'));
      setOpen(true);
      return;
    }

    dispatch(answeredToPage({
      pageIndex,
    }))

    const toUrlInputNext = generatePath(
      appPath.shopqr.inputAnswer,
      {
        [paramName.surveyQestionPageIndexStr]: pageIndex + 1,
      }
    )

    history.push(toUrlInputNext);

    return false;
  }

  const handlePrevClick = () => {
    if (errorCount > 0) {
      setErrorMessage(t("common.error.an_item_was_not_filled_in_correctly"));
      setOpen(true);
      return;
    }
    let toUrlInputPrev: string = generatePath(appPath.shopqr.inputBranch);
    if (pageIndex > 0) {
      toUrlInputPrev = generatePath(appPath.shopqr.inputAnswer, {
        [paramName.surveyQestionPageIndexStr]: pageIndex - 1,
      });
    }

    history.replace(toUrlInputPrev);
    return false;
  }

  const handleClose = () => {
    setOpen(false);
  };

  // 前へ、次へ、回答を送信ボタン
  // 最初のページのボタンをデフォルトでセット
  let Buttons = 
    <>
      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        onClick={handleNextClick}
        data-qa={DATA_QA.BUTTON.NEXT}
      >{t('question.btn.next')}</Button>
    </>;
  
  if (pageIndex === cxQuestionPages.length - 1) {
    // 最後のページの場合

    if (pageIndex === 0) {
      // 最初でかつ最後のページの場合
      // 回答を送信ボタンしか表示しない
      Buttons = isCommonQR ? (
        <Grid container>
          <Grid item xs={6}>
            <Box mr={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={handlePrevClick}
              >
                {t('question.btn.back')}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box ml={1}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSendClick}
                data-qa={DATA_QA.BUTTON.SUBMIT}
              >
                {sendTitle}
              </Button>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSendClick}
            data-qa={DATA_QA.BUTTON.SUBMIT}
          >
            {sendTitle}
          </Button>
        </>
      );
    } else {
      // ２ページ目以降で最後のページの場合
      // 前へ、回答を送信の二つを表示
      Buttons = (
        <>
          <Grid container>
            <Grid item xs={6}>
              <Box mr={1}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={handlePrevClick}
                >
                  {t('question.btn.back')}
                </Button>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box ml={1}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleSendClick}
                  data-qa={DATA_QA.BUTTON.SUBMIT}
                >
                  {sendTitle}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </>
      );
    }
  } else if (pageIndex > 0) {
    // 中間ページの場合
    Buttons = (
      <>
        <Grid container>
          <Grid item xs={6}>
            <Box mr={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={handlePrevClick}
              >
                {t('question.btn.back')}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box ml={1}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={handleNextClick}
                data-qa={DATA_QA.BUTTON.NEXT}
              >
                {t('question.btn.next')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </>
    );
  } else if (pageIndex === 0 && isCommonQR) {
    Buttons = (
      <Grid container>
        <Grid item xs={6}>
          <Box mr={1}>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={handlePrevClick}
            >
              {t('question.btn.back')}
            </Button>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box ml={1}>
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={handleNextClick}
              data-qa={DATA_QA.BUTTON.NEXT}
            >
              {t('question.btn.next')}
            </Button>
          </Box>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      {Buttons}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            { errorMessage }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="contained" autoFocus>
            {t('question.btn.ok')}
          </Button>
        </DialogActions>
      </Dialog>          
    </>
  )
}
